import {PureComponent} from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'

import ContactDetail from './ContactDetail.jsx'
import MeetingStep from './MeetingStep.jsx'
import CVStep from './CVStep.jsx'
import AdditionalInfoStep from './AdditionalInfoStep.jsx'
import StepLayout from '../../../components/RegistrationSteps/StepLayout.jsx'
import MeetingConfirmationStep from "./MeetingConfirmationStep.jsx"
import PresentationStep from "./PresentationStep.jsx"
import MissionsStep from "./MissionsStep.jsx"
import ValidationStep from "./ValidationStep.jsx"
import { UserInteractionProvider } from '../../../../shared/contexts/UserInteractionContext.jsx'
import CvDataComparisonForm from '../Containers/CvDataComparison/CvDataComparisonForm.jsx'
import {CREATE_FREELANCE_STEPS, updateCreatFreelanceStep} from "../../../../shared/containers/Freelance/setNextStep.js"

export default class CvDataComparisonStepView extends PureComponent {
  static propTypes = {
    currentStep: PropTypes.number.isRequired,
    currentUser: PropTypes.object.isRequired,
    profile: PropTypes.shape({
      freelance: PropTypes.object.isRequired,
      user: PropTypes.object.isRequired,
    }).isRequired,
    submit: PropTypes.func.isRequired,
    refresh: PropTypes.func.isRequired,
    analyse: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  handleSaveSuccess = (updatedFreelance) => {
    const {agent, ...freelanceData} = updatedFreelance
    const nextStep = CREATE_FREELANCE_STEPS.VALIDATION

    updateCreatFreelanceStep(
      freelanceData.id,
      nextStep,
      () => this.props.submit({
        freelance: {
          ...freelanceData
        },
        silentMode: true,
      })
    )
    this.props.history.push('/create/freelance')
  }

  render() {
    const {currentUser, currentStep, profile, history, analyse} = this.props

    const helmet = <Helmet>
      <title>Comparaison des données du CV</title>
    </Helmet>

    const steps = [
      {label: 'Contact', duration: '30 sec', component: ContactDetail},
      {label: 'Planifier une visio', duration: '30 sec', component: MeetingStep},
      {label: 'CV', duration: '1 min', component: CVStep},
      {label: 'Validation', duration: '1 min', component: AdditionalInfoStep},
      {label: 'RDV planifié', duration: '1 min', component: MeetingConfirmationStep},
      {label: 'Présentation', duration: '1 min', component: PresentationStep},
      {label: 'Missions', duration: '1 min', component: MissionsStep},
      {label: 'Validation', duration: '1 min', component: ValidationStep},
    ]

    return <UserInteractionProvider>
      <StepLayout
        currentStep={5}
        helmet={helmet}
        steps={steps}
        title="S'inscrire - Consultant"
      >
        <CvDataComparisonForm
          analyse={analyse}
          freelance={profile.freelance}
          user={profile.user}
          onSave={this.handleSaveSuccess}
          isRegistrationFlow={true}
        />
      </StepLayout>
    </UserInteractionProvider>
  }
}
